/**
 * The default luckysheet config object.
 */
export default {
    container: "luckysheet", // Container ID
    loading: {}, // Custom loading
    column: 60, // Default number of columns in empty table
    row: 84, // Default number of rows in empty table
    allowCopy: true, // Whether to allow copy
    showtoolbar: true, // Whether to show toolbar
    showinfobar: true, // Whether to show top info bar
    showsheetbar: true, // Whether to show bottom sheet bar
    showstatisticBar: true, // Whether to show bottom statistic bar
    pointEdit: false, // Whether in editor insert table mode
    pointEditUpdate: null, // Editor table update function
    pointEditZoom: 1, // Editor table zoom ratio when editing
    // menu: "undo|redo|freezenrow|freezencolumn|download|share|chart|pivot",
    data: [{ "name": "Sheet1", color: "", "status": "1", "order": "0", "data": [], "config": {}, "index": 0 }, { "name": "Sheet2", color: "", "status": "0", "order": "1", "data": [], "config": {}, "index": 1 }, { "name": "Sheet3", color: "", "status": "0", "order": "2", "data": [], "config": {}, "index": 2 }], // Client sheet data [sheet1, sheet2, sheet3]
    title: "Luckysheet Demo", // Table name
    userInfo: false,// User info display style in top right corner. Supports: 1. boolean: false=hide, true=show default, 2. HTML template string or plain string, 3. Object format with userImage and userName, 4. undefined same as false
    userMenuItem: [{ url: "www.baidu.com", "icon": '<i class="fa fa-folder" aria-hidden="true"></i>', "name": "My Tables" }, { url: "www.baidu.com", "icon": '<i class="fa fa-sign-out" aria-hidden="true"></i>', "name": "Logout" }], // Menu that pops up when clicking user info in top right
    myFolderUrl: "www.baidu.com", // Link for back button in top left corner
    config: {}, // Table row height, column width, merged cells, formulas, etc.
    fullscreenmode: true, // Whether fullscreen mode, in non-fullscreen mode, selection box won't force select
    devicePixelRatio: window.devicePixelRatio, // Device pixel ratio, higher ratio means higher table resolution
    allowEdit: true, // Whether to allow frontend editing
    loadUrl: "", // Configure loadUrl address, luckysheet will request table data via ajax, default loads all data from sheet with status=1, other sheets load all fields except data
    loadSheetUrl: "", // Configure loadSheetUrl address, parameters are gridKey (table primary key) and index (sheet primary key collection, format [1,2,3]), returns sheet data field collection
    gridKey: "", // Table unique identifier
    updateUrl: "", // Table data update address
    updateImageUrl: "", // Thumbnail update address
    allowUpdate: false, // Whether to allow backend update after editing
    functionButton: "", // Function buttons in top right corner, e.g. download, share, show data buttons
    showConfigWindowResize: true, // Chart and pivot table config pops up on right, sets whether table auto-indents after popup
    enableAddRow: true,// Allow adding rows
    enableAddBackTop: true,// Allow back to top
    // enablePage: false,//允许加载下一页
    autoFormatw: false,  // Auto format numbers over 4 digits to billion/million format e.g.: true or "true" or "TRUE"
    accuracy: undefined,  // Set precision of transmitted values, n digits after decimal point, parameter is number or number string, e.g.: "0" or 0
    pageInfo: {
        'queryExps': '',
        'reportId': '',
        'fields': '',
        'mobile': '',
        'frezon': '',
        'currentPage': '',
        "totalPage": 10,
        "pageUrl": "",
    },
    editMode: false, // Whether in edit mode
    beforeCreateDom: null,// Method before table creation
    fireMousedown: null, // Cell data drill-down
    lang: 'en', //language
    plugins: [], //plugins, e.g. ['chart']
    forceCalculation: false,// Force refresh formulas, may have performance issues with many formulas, use with caution
    rowHeaderWidth: 46,
    columnHeaderHeight: 20,
    defaultColWidth: 73,
    defaultRowHeight: 19,
    defaultFontSize: 10,
    limitSheetNameLength: true,    // Whether to limit worksheet name length
    defaultSheetNameMaxLength: 31,  // Default maximum worksheet name length
    sheetFormulaBar: true, // Whether to show formula bar
    showtoolbarConfig: {}, // Custom toolbar
    showsheetbarConfig: {}, // Custom bottom sheet bar
    showstatisticBarConfig: {}, // Custom statistic bar
    cellRightClickConfig: {}, // Custom cell right-click menu
    sheetRightClickConfig: {}, // Custom bottom sheet right-click menu
    imageUpdateMethodConfig: {}, //自定义图片同步方式
}
